import { render, staticRenderFns } from "./destinationsSideView.vue?vue&type=template&id=57754f28"
import script from "./destinationsSideView.vue?vue&type=script&lang=js"
export * from "./destinationsSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports